import { useSelector } from "react-redux";
import { Step, IStore } from "../../DataTypes/storeTypes";
import { Location } from "./Location";
import { Service } from "./Service";
import { Provider } from "./Provider";
import { Header } from "./Header";
import { AvailabilityConnected } from "./Availability/Availability";
import { LoginWrapperConnected } from "./Login/LoginWrapper";
import ConfirmationStep from "./Confirmation/Index";
import { EnumValues } from "../../../Common/enumHelper";
import Loading from "../../../Common/Loading";

export const StepsPanel = () => {
    const {
        common: { isPageLoading, currentStep },
    } = useSelector((state: IStore) => state);

    let step = null;
    let stepsValues = EnumValues.getValues(Step);

    switch (currentStep) {
        case Step.Location:
            step = <Location />;
            break;
        case Step.Service:
            step = <Service />;
            break;
        case Step.Provider:
            step = <Provider />;
            break;
        case Step.When:
            step = <AvailabilityConnected />;
            break;
        case Step.Login:
            step = <LoginWrapperConnected />;
            break;
        case Step.Confirmation:
            step = <ConfirmationStep />;
            break;
    }

    if (isPageLoading) {
        step = (
            <div className="w-100 text-center">
                <Loading />
            </div>
        );
    }

    return (
        <>
            <div className="row appt-progress">
                <div className="col text-center">
                    <div className="appt-progress-bar">
                        {stepsValues.map((i) => {
                            let child = currentStep > Number(i) ? <i className="fa fa-check" /> : null;
                            let klass = currentStep > Number(i) ? " passed" : "";
                            klass += currentStep === Number(i) ? " current" : "";

                            return (
                                <span key={i} className={klass.trim()}>
                                    {child}
                                </span>
                            );
                        })}
                    </div>
                </div>
            </div>

            <Header />

            <div className="row">
                <div className="col-12">{step}</div>
            </div>
        </>
    );
};
